const PetitionsModule = () => import('@pages/petitions/PetitionsModule')
const IntenalsPetitionsIndex = () => import('@pages/petitions/internals/InternalsPetitionIndex')
const AdministrationPetitionsIndex = () => import('@pages/petitions/administration/AdministrationPetitionsIndex')

export default {
    path: 'petitions',
    component: PetitionsModule,
    children: [
        {
            path: 'internals',
            component: IntenalsPetitionsIndex,
            name: 'internalsPetitions',
        },
        {
            path: 'administration',
            component: AdministrationPetitionsIndex,
            name: 'administratorPetitions',
            props: true,
        },
    ],
}
